import { useState } from "react";
import { Container, Row, Col, Pagination, Spinner } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import UserItemShop from "../../components/UserShopItem/UserItemShop";
import UserShopProfile from "../../components/UserShopProfile/UserShopProfile";
import BackArrow from "../../components/backArrow";

import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  useGetShopByIdQuery,
  useGetShopItemsQuery,
} from "../../features/shop/shopApiSlice";
import { decodeId } from "../../utils/idObfuscator";

const LIMIT = 15;
const RETAILER_BT = "retailerShop";

const RetailerItem = () => {
  const { shopid: rawShopid } = useParams();
  const shopid = decodeId(rawShopid) || rawShopid;
  const { name } = useSelector((state) => state.user);

  const [page, setPage] = useState(1);
  const [lgShowreport, setLgShowreport] = useState(false);
  const [active, setActive] = useState(null);
  const [createShop, setCreateShop] = useState({
    userid: name?._id,
    username: name?.fullname,
    imgurl: name?.imageUrl,
    problem: "",
    desciription: "",
    image: [""],
  });

  const { data: shopRes, error: shopError, isFetching: loadingShop } =
    useGetShopByIdQuery(shopid, { skip: !shopid });
  const shopData = shopRes?.data?.Shop;

  const { data: itemsRes, isFetching: loading } = useGetShopItemsQuery(
    { shopid, page, limit: LIMIT },
    { skip: !shopid },
  );

  const itemshow = itemsRes?.regular || [];
  const specialoffer = itemsRes?.specialoffer || [];
  const salepromotion = itemsRes?.salespromotion || [];
  const totalPages = itemsRes?.totalPages || 1;
  const newItemdata = [...itemshow, ...specialoffer, ...salepromotion];

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleLikeDislike = (rating) => setActive(rating);

  return (
    <Container className="user-shop-page">
      <div className="user-shop-mobile-back d-lg-none">
        <BackArrow back="/buy-retailer" mystyle="pt-1 ps-2" />
      </div>
      <Row className="align-items-start">

        {/* ── Left: Shop Profile Sidebar ── */}
        <Col
          xl={3}
          lg={4}
          className="p-0 user-shop-profile-column"
        >
          <div className="border b-radius h-100">
            {loadingShop ? (
              <Skeleton height={400} />
            ) : shopError ? (
              <div
                className="p-3 text-center text-danger border rounded bg-light"
                style={{ minHeight: "400px" }}
              >
                <h5>Error Loading Shop</h5>
                <p>
                  Could not load shop profile.{" "}
                  {shopError?.data?.message || "Please try again later."}
                </p>
              </div>
            ) : shopData ? (
              <UserShopProfile
                shopData={shopData}
                shopid={shopid}
                lgShowreport={lgShowreport}
                setLgShowreport={setLgShowreport}
                setCreateShop={setCreateShop}
                handleLikeDislike={handleLikeDislike}
                active={active}
              />
            ) : (
              <div
                className="p-3 text-center text-muted border rounded bg-light"
                style={{ minHeight: "400px" }}
              >
                <h5>Shop Not Found</h5>
                <p>
                  The shop profile you are looking for does not exist or has
                  been removed.
                </p>
              </div>
            )}
          </div>
        </Col>

        {/* ── Right: Items ── */}
        <Col xl={9} lg={8} className="user-shop-items-column ps-3 pe-0">
          <div className="border b-radius" style={{ backgroundColor: "#fafafa" }}>
            <div className="ms-3 d-none d-lg-block">
              <BackArrow back="/buy-retailer" />
            </div>

            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "200px" }}
              >
                <Spinner
                  animation="border"
                  role="status"
                  style={{ color: "#0353A4", width: "48px", height: "48px" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <>
                <UserItemShop
                  shopid={shopid}
                  regular={itemshow}
                  specialoffer={specialoffer}
                  salespromotion={salepromotion}
                  newItemdata={newItemdata}
                  shopData={shopData}
                  isDynamic={true}
                />
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center mt-3 mb-3">
                    <Pagination>
                      <Pagination.First
                        onClick={() => handlePageChange(1)}
                        disabled={page === 1}
                      />
                      <Pagination.Prev
                        onClick={() => handlePageChange(page - 1)}
                        disabled={page === 1}
                      />
                      {Array.from({ length: totalPages }, (_, i) => (
                        <Pagination.Item
                          key={i + 1}
                          active={i + 1 === page}
                          onClick={() => handlePageChange(i + 1)}
                        >
                          {i + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next
                        onClick={() => handlePageChange(page + 1)}
                        disabled={page === totalPages}
                      />
                      <Pagination.Last
                        onClick={() => handlePageChange(totalPages)}
                        disabled={page === totalPages}
                      />
                    </Pagination>
                  </div>
                )}
              </>
            )}
          </div>
        </Col>

      </Row>
    </Container>
  );
};

export default RetailerItem;
